import { useAbility } from '../contexts/AbilityContext';
import { ACTIONS, SUBJECTS } from '../constants/permissions';

/**
 * Custom hook that provides employee permission checking functions
 * @returns {Object} Object containing permission checking functions
 */
export const useEmployeePermissions = () => {
  const ability = useAbility();

  /**
   * Check if user can manage an employee based on their cluster or manager
   * @param {Object} employee - The employee object to check permissions for
   * @returns {boolean} True if user can manage the employee
   */
  const canManageEmployee = (employee) => {
    if (!employee) {
      return false;
    }

    let canManageEmployeeCluster = false;
    let canManageEmployeeManager = false;

    // Check cluster-based management if cluster exists
    if (employee.cluster) {
      const employeeClusterObject = {
        clusterId: employee.cluster.id,
        __type: SUBJECTS.EMPLOYEE
      };
      canManageEmployeeCluster = ability.can(ACTIONS.MANAGE, employeeClusterObject);
    }

    // Check manager-based management if directManager exists
    if (employee.directManager) {
      const employeeManagerObject = {
        directManagerId: employee.directManager.id,
        __type: SUBJECTS.EMPLOYEE
      };
      canManageEmployeeManager = ability.can(ACTIONS.MANAGE, employeeManagerObject);
    }

    return canManageEmployeeCluster || canManageEmployeeManager;
  };

  return {
    canManageEmployee
  };
};
